import { NavResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: NavResult;
  translations: ToolsTranslations['nav'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  if (!result.isValid) {
    return (
      <div className="space-y-6">
        <h3 className="text-lg font-medium text-gray-900">{translations.results.title}</h3>
        <div className="p-4 bg-red-50 border border-red-200 rounded-md">
          <p className="text-sm text-red-600">{result.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900">{translations.results.title}</h3>
      
      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="text-center">
            <p className="text-sm text-blue-600 mb-2">{translations.results.navLabel}</p>
            <p className="text-3xl font-bold text-blue-900">
              {result.nav?.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kr
            </p>
          </div>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <div className="text-center">
            <p className="text-sm text-gray-600 mb-1">{translations.results.netAssetsLabel}</p>
            <p className="text-xl font-semibold text-gray-800">
              {result.netAssets?.toLocaleString('sv-SE')} kr
            </p>
          </div>
        </div>
      </div>

      <div className="text-sm text-gray-600 space-y-2">
        <p>{translations.results.explanation}</p>
        <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
          <p className="text-xs text-yellow-800">
            <strong>{translations.results.note}:</strong> {translations.results.noteText}
          </p>
        </div>
      </div>
    </div>
  );
}
